import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ReplaySubject } from 'rxjs';
import { map, shareReplay, startWith } from 'rxjs/operators';
import { environment as env } from '../../environments/environment';
import { User, USER_ROLE } from '../models/user.model';

@Injectable({
  providedIn: 'root'
})
export class UserApiService {

  private $user = new ReplaySubject<User>(1);
  public user$ = this.$user.pipe(shareReplay(1));
  public isInternalUser$ = this.user$.pipe(
    map(user => user.role === USER_ROLE.INTERNAL),
    shareReplay(1)
  );
  public languageCode$ = this.user$.pipe(
    map(user => {
      let code = user?.languageCode?.toLocaleLowerCase() || 'en-GB';
      code = code === 'en' ? 'en-GB' : user.languageCode;
      return code;
    }),
    startWith('en-GB'),
    shareReplay(1)
  );

  constructor(private http: HttpClient) {
    this.fetch();
  }

  fetch() {
    this.http.get<User>(`${env.apiPath}/user`)
      .subscribe(user => this.$user.next(user));
  }

  setCurrentUserLanguage(code: string) {
    const languageCode = code ? code.substring(0, 2).toLocaleLowerCase() : 'en';
    this.http.patch<User>(`${env.apiPath}/user`, JSON.stringify({ languageCode }))
      .subscribe(updatedUser => {
        console.log('UserApiService: PATCH user OK', updatedUser);
        this.$user.next(updatedUser);
      });
    return this.languageCode$;
  }
}
